import { useMemo } from "react";
import {
  LoadingOutlined,
  InteractionOutlined,
} from "@ant-design/icons";
import { TextEnum } from "../../text";
import { PushMessage } from "../../entity";
import { RootState } from "../../../store";
import { CustomPopConfirm } from "../popconfirm";
import deleteIcon from "../../../static/trash.svg";
import { deletePushMessage } from "../../../actions/push-message";
import { useAppSelector } from "../../global-hooks";

type PushMessageColumnsProps = {
  handleModalVisible: (id: number) => void;
};

export const PushMessageColumns = ( { handleModalVisible }: PushMessageColumnsProps ) => {
  const { pushMessageActionStart } =
    useAppSelector((state: RootState) => state.pushMessage);

  const handleDelete = async (id: number) => {
    await deletePushMessage({ id });
  };

  return useMemo(() => {
    const columns = [
      {
        title: TextEnum.PUSH_MESSAGE_TITLE_NAME,
        key: TextEnum.PUSH_MESSAGE_TITLE_NAME,
        render: (text: string, record: PushMessage) => {
          return record.title.length > 100
            ? record.title.substring(0, 100) + "..."
            : record.title;
        },
        width: "200px",
      },
      {
        title: TextEnum.PUSH_MESSAGE_BODY_NAME,
        key: TextEnum.PUSH_MESSAGE_BODY_NAME,
        render: (text: string, record: PushMessage) => {
          return record.body.length > 100
            ? record.body.substring(0, 100) + "..."
            : record.body;
        },
      },
      {
        title: TextEnum.PUSH_MESSAGE_SEND_DATE,
        key: TextEnum.PUSH_MESSAGE_SEND_DATE,
        render: (text: string, record: PushMessage) => {
          return new Date(record.sendDate).toLocaleDateString();
        },
        width: "150px",
      },
      {
        title: TextEnum.DELETE,
        key: TextEnum.DELETE,
        render: (text: string, record: PushMessage) => {
          return (
            <div>
              <CustomPopConfirm
                title={TextEnum.PUSH_MESSAGE_DELETE_POPUP_CONFIRM}
                okText={TextEnum.YES}
                cancelText={TextEnum.NO}
                onConfirm={() => handleDelete(record.id)}
                disabled={false}
              >
                <button
                  disabled={pushMessageActionStart}
                  className="company-table-delete-button"
                >
                  {pushMessageActionStart ? (
                    <LoadingOutlined />
                  ) : (
                    <img
                      className="table-icon"
                      src={deleteIcon}
                      alt={deleteIcon}
                    />
                  )}
                </button>
              </CustomPopConfirm>
            </div>
          );
        },
        width: "100px",
      },
    ];
    return columns.filter((column) => column.key !== TextEnum.RESTORE);
  }, [
        pushMessageActionStart,
  ]);
};
